import { BlogPostCover } from './BlogPostCover'
import { BlogTagList } from './BlogTagList'
import type { BlogPost } from '@/features/blog/types/blog.types'
import {
  estimateReadingTime,
  formatPostDate,
} from '@/features/blog/utils/blogFormatters'

interface BlogPostHeaderProps {
  post: BlogPost
}

export function BlogPostHeader({ post }: BlogPostHeaderProps) {
  const readingTime = estimateReadingTime(post.content)
  const displayDate = post.publishedAt || post.createdAt

  return (
    <header className="mb-10">
      <BlogTagList tags={post.tags} variant="primary" className="mb-5" />

      <h1 className="text-sheen pb-1 text-3xl font-semibold leading-[1.05] tracking-[-0.04em] text-balance sm:text-4xl lg:text-5xl">
        {post.title}
      </h1>

      {post.excerpt && (
        <p className="mt-5 text-lg leading-relaxed text-[var(--color-text-secondary)]">
          {post.excerpt}
        </p>
      )}

      {/* Key/value strip: the article's metadata read as a record. */}
      <dl className="mt-7 flex flex-wrap gap-x-6 gap-y-2 border-y border-[var(--color-border)] py-3 font-mono text-caption tabular-nums text-[var(--color-text-tertiary)]">
        <div className="flex items-baseline gap-2">
          <dt>published</dt>
          <dd className="text-[var(--color-text-primary)]">
            <time dateTime={displayDate}>{formatPostDate(displayDate)}</time>
          </dd>
        </div>
        <div className="flex items-baseline gap-2">
          <dt>read time</dt>
          <dd className="text-[var(--color-text-primary)]">
            {readingTime} min
          </dd>
        </div>
      </dl>

      {post.coverImage && (
        <BlogPostCover
          title={post.title}
          coverImage={post.coverImage}
          className="mt-8 rounded-[1.5rem] border border-[var(--color-border)]"
        />
      )}
    </header>
  )
}
